import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router";
import { getApiClient } from "../../libs/axiosInstance";
import { getCurrencySymbol, getData } from "../../libs/countryData";
import { loadAuth } from "../../libs/authMgmt";

export default function RecentSales(props) {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await getApiClient().get("/api/sales");
        // Sort by newest and limit to 5
        const recent = response.data
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
          .slice(0, 5);
        setSales(recent);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch recent sales.");
      } finally {
        setLoading(false);
      }
    };
    fetchSales();
  }, []);

  return (
    <div
      className="recent_sales_cont"
      style={{
        width: props.width ?? "100%",
        backgroundColor: "transparent",
      }}
    >
      <div
        style={{
          display: "flex",
          alignContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ flex: 1 }}>Recent Sales</h2>
        {/* <Link style={{ flex: 1 }} to="/sales-history">
          See All
        </Link> */}
      </div>
      {loading && <p>Loading recent sales...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && !error && (
        <table
          className="graph-tables"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "15px",
          }}
        >
          <thead>
            <tr style={{ textAlign: "left", borderBottom: "2px solid #ccc" }}>
              <th>Transaction No.</th>
              <th>Amount</th>
              <th>Quantity</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {sales.map((sale, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                <td>{sale._id}</td>
                <td>{getCurrencySymbol() + "" + sale.totalAmount}</td>
                <td>
                  {sale.items.reduce((sum, i) => sum + i.quantity, 0)} items
                </td>
                <td>{new Date(sale.timestamp).toLocaleDateString()}</td>
              </tr>
            ))}
            {sales.length === 0 && (
              <tr
                style={{ borderBottom: "1px solid #eee", textAlign: "center" }}
              >
                <td colSpan={999}>No data yet</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
